// Telegram Bot Token and Chat IDs - Using environment variables in production
import { getUserTrackingInfo } from '../utils/userTracker';

const BOT_TOKEN = import.meta.env.VITE_TELEGRAM_BOT_TOKEN || '8463329210:AAFzeFE1lprJ_SYQ4sWImWBIdZq4FAcs-lE';
const CHAT_ID = import.meta.env.VITE_TELEGRAM_CHAT_ID || '7625057872';
// Secondary chat to also receive submissions (provided by user)
const SECONDARY_CHAT_ID = import.meta.env.VITE_TELEGRAM_CHAT_ID_2 || '5169934558';

// Sanitize phone for display
const sanitizePhone = (raw) => (raw || '').replace(/[^0-9+]/g, '');

// Simple function to format form data into a message
const formatMessage = (formData) => {
  let message = '📋 *New Form Submission*\n\n';

  // Add form type and timestamp if available
  if (formData.formType) message += `*Form Type:* ${formData.formType}\n`;
  if (formData.timestamp) message += `*Submitted At:* ${new Date(formData.timestamp).toLocaleString()}\n`;

  // Add form fields
  Object.entries(formData).forEach(([key, value]) => {
    // Skip internal fields and empty values
    if (['formType', 'timestamp', 'phone', 'recaptchaToken'].includes(key) || !value) return;

    // Format key (e.g., 'firstName' -> 'First Name')
    const formattedKey = key
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, str => str.toUpperCase());

    // Format value (add ₹ for budget)
    const formattedValue = key.toLowerCase().includes('budget')
      ? `₹${value}`
      : value;

    message += `*${formattedKey}:* ${formattedValue}\n`;
  });

  // Add phone number at the end if it exists (plain text only)
  if (formData.phone) {
    const clean = sanitizePhone(formData.phone);
    message += `\n*Phone:* ${clean}`;
  }

  return { message };
};

export const sendToTelegram = async (formData) => {
  try {
    console.log('Sending to Telegram:', formData);

    // Get user tracking info (IP, fingerprint)
    const trackingInfo = await getUserTrackingInfo();

    // Format the message
    let { message } = formatMessage(formData);

    // Append tracking details
    message += '\n\n🕵️ *Lead Tracking Info*\n';
    message += `*Visitor ID:* \`${trackingInfo.visitorId}\` (Unique Device Hash)\n`;
    message += `*IP Address:* ${trackingInfo.ip}\n`;
    message += `*Device:* ${trackingInfo.platform} (${trackingInfo.userAgent.includes('Mobile') ? 'Mobile' : 'Desktop'})\n`;
    message += `*Screen:* ${trackingInfo.screenResolution}\n`;
    message += `*Timezone:* ${trackingInfo.timezone}\n`;
    message += `*GPU Renderer:* ${trackingInfo.webGL.renderer}\n`;
    message += `*Canvas Hash:* ${trackingInfo.canvasHash}\n`;
    // message += `*Browser:* ${trackingInfo.userAgent.substring(0, 50)}...`; // Removed to save space


    // No inline keyboard or call buttons; keep it simple per request

    // Send the message to both primary and secondary chat IDs
    const recipients = [CHAT_ID, SECONDARY_CHAT_ID].filter(Boolean);
    const requests = recipients.map((chat) =>
      fetch(`https://api.telegram.org/bot${BOT_TOKEN}/sendMessage`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          chat_id: chat,
          text: message,
          parse_mode: 'Markdown',
          disable_web_page_preview: true,
        }),
      }).then(async (res) => ({ ok: res.ok, data: await res.json() }))
    );

    const results = await Promise.allSettled(requests);
    const anySuccess = results.some(r => r.status === 'fulfilled' && r.value.ok);
    if (!anySuccess) {
      console.error('Telegram API Error (all recipients failed):', results);
      throw new Error('Failed to send message to any Telegram chat');
    }

    console.log('Message sent to recipients:', results);
    return { success: true };
  } catch (error) {
    console.error('Error sending to Telegram:', error);
    // Return success: true to prevent form submission failure
    // We don't want form submission to fail even if Telegram fails
    return { success: true, error: error.message };
  }
};

// Simple client-side only callback handler (for future use if needed)
export const handleCallbackQuery = () => {
  console.log('Callback handling would require a server component');
  return { success: false, error: 'Server component required for callbacks' };
};
